import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import editIcon from 'images/icon/edit_icon_121212-38x38.png';
import rightArrowIcon from 'images/icon/arrow-right-121212-15x27.png';

//캠페인 하단
export default function CampaignMainFooterJoinBtn({
												type,remainingDay, campaignNo,
												onJoinCampaign, onShowJoinStatus, onShowDeniedReasonBtn }) {
	const currLink = window.location.href;
	const joinBtnDom = []
	if(type === 'loginReq'){

		joinBtnDom.push(
			<RedirectBtn key={'campaign-redirect-task-list-btn'} to={`/social?redirect_path=/campaign/${campaignNo}/info`}>
				{`챌린지 참여하기`} 
			</RedirectBtn>)
	}
	else if(type === 'redirectAppStore')
	{
		joinBtnDom.push(
			<RedirectStoreBtn key={'campaign-redirect-task-list-btn'} href={`https://plink.motiners.com/?link=${currLink}&apn=com.motiners.bundle&isi=1556370860&ibi=com.motiners.motinersapp`} targe={'_blank'}>
				{`챌린지 참여하기`} 
			</RedirectStoreBtn>)
	}
	else if(type === 'joinReqBtn')
	{
		joinBtnDom.push(<FooterBtn key={'campaign-join-btn'} onClick={()=>{if(onJoinCampaign)onJoinCampaign()}}>챌린지 참여하기</FooterBtn>)
	}
	else if(type === 'checkJoinStatus')
	{
		joinBtnDom.push(
			<FooterBtn key={'campaign-show-join-status-btn'} onClick={()=>{if(onShowJoinStatus)onShowJoinStatus()}}>
				{`내 참여정보 보기`}
				<RightIconWrapper width={17} height={17}>
					<IconImg src={editIcon}/>
				</RightIconWrapper>
			</FooterBtn>)
	}
	else if(type === 'checkDeniedReason')
	{
		joinBtnDom.push(
			<FooterBtn key={'campaign-show-denied-join-btn'} bgcolor={'#EC7258'} onClick={()=>{if(onShowDeniedReasonBtn)onShowDeniedReasonBtn()}}>
				{`승인거절 사유 보기`} 
				<RightIconWrapper width={10} height={16}>
					<IconImg src={rightArrowIcon}/>
				</RightIconWrapper> 
			</FooterBtn>)
	}
	else if(type === 'remainingDay' && remainingDay)
	{
		joinBtnDom.push(
			<FooterBtn key={'campaign-show-remained-date-btn'} bgcolor={'#FFE78C'} color={'#7F7F7F'}>
				{`D-${remainingDay} 챌린지 시작`} 
			</FooterBtn>)
	}
	else if(type === 'redirectTaskListBtn')
	{
		joinBtnDom.push(
			<RedirectBtn key={'campaign-redirect-task-list-btn'} to={'/task/list'}>
				{`인증하기`} 
			</RedirectBtn>)
	}
	else if(type === 'disabledTaskListBtn')
	{
		joinBtnDom.push(
			<FooterBtn key={'campaign-disabled-redirect-task-list-btn'} bgcolor={'#FFE78C'} color={'#7F7F7F'}>
				{`오늘은 인증하는 날이 아니에요`} 
			</FooterBtn>)
	}
	else if(type === 'expired')
	{
		joinBtnDom.push(
			<FooterBtn key={'campaign-expired-btn'} bgcolor={'#4E4E4E'} color={'#FFFFFF'}>
				{`챌린지 마감`} 
			</FooterBtn>)
	}
	return (
		<>
		<DummySpacer></DummySpacer>
			<Campaignfooter>
				{joinBtnDom}
			</Campaignfooter>
		</>
	)
}


export const Campaignfooter = styled.div`
	position: fixed;
	position: ${({ position }) => position};
	bottom: 0;
	left: 0;
	width: 100%;
	height: calc(100vw * (72 / 375));
	z-index: 400;
`;
export const DummySpacer = styled.div`
	height: calc(100vw * (72 / 375));
`;
export const FooterBtn = styled.button`
	width: 100%;
	height: calc(100vw * (72 / 375));
	font-size: calc(100vw * (18 / 375));
	font-weight: 700;
	letter-spacing: calc(100vw * (0.25 / 375));
	text-align: center;
	color: ${({color}) => (color)?color:'#121212'};
	background-color: #ffcf19;
	background-color: ${(props) => props.bgcolor};
	display :flex;
	align-items: center;
	justify-content: center;
`;

export const RedirectBtn = styled(Link)`
	width: 100%;
	height: calc(100vw * (72 / 375));
	font-size: calc(100vw * (18 / 375));
	font-weight: 700;
	letter-spacing: calc(100vw * (0.25 / 375));
	text-align: center;
	color: ${({color}) => (color)?color:'#121212'};
	background-color: #ffcf19;
	background-color: ${(props) => props.bgcolor};
	display :flex;
	align-items: center;
	justify-content: center;
`

export const RedirectStoreBtn = styled.a`
	width: 100%;
	height: calc(100vw * (72 / 375));
	font-size: calc(100vw * (18 / 375));
	font-weight: 700;
	letter-spacing: calc(100vw * (0.25 / 375));
	text-align: center;
	color: ${({color}) => (color)?color:'#121212'};
	background-color: #ffcf19;
	background-color: ${(props) => props.bgcolor};
	display :flex;
	align-items: center;
	justify-content: center;
`

export const RightIconWrapper = styled.div`
	margin-left: calc(100vw * (10 / 375));
	display: inline-block;
	width : calc(100vw * (${({ width }) => (width)?width : 17} / 375));
	height : calc(100vw * (${({ height }) => (height)?height : 17} / 375));
`
export const IconImg = styled.img`
	width : 100%;
	height: 100%;
	object-fit: cover;
`